<app-progress></app-progress>
<div class="mat-typography">
  <!-- TODO: This is a hack... Add a blank mat-table to force the styles to be imported -->
  <mat-table style="display: none">
    <mat-header-row *matHeaderRowDef="[]"></mat-header-row>
  </mat-table>
  @if (searchKeyFetched | async) {
    <!--ais-instantsearch [config]="searchConfig" fxFlex="90%">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Search Items</mat-card-title>
          <mat-card-subtitle>
            <ais-search-box></ais-search-box>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="mat-elevation-z8">
          <ais-hits>
            <ng-template let-hits="hits">
              <table class="mat-table">
                <thead>
                  <tr class="mat-header-row">
                    <th class="mat-header-cell">Customer Part Number</th>
                    <th class="mat-header-cell">Facility</th>
                    <th class="mat-header-cell">Location</th>
                    <th class="mat-header-cell">Unique Item ID</th>
                    <th class="mat-header-cell">Item Type</th>
                    <th class="mat-header-cell">Eclipse ID</th>
                  </tr>
                </thead>
                <tbody>
                  @for (hit of hits; track hit) {
                    <tr class="mat-row">
                      <td class="mat-cell">
                        <ais-highlight class="cursor-pointer" [hit]="hit" attribute="customerPartNumber"
                          [routerLink]="['/item', hit.objectID]">
                        </ais-highlight>
                      </td>
                      <td class="mat-cell">
                        <ais-highlight class="cursor-pointer" [hit]="hit"
                          [routerLink]="['/facilities' , hit.facility, 'locations']"
                        attribute="facilityName"></ais-highlight>
                      </td>
                      <td class="mat-cell">
                        @if (hit.location) {
                          <ais-highlight class="cursor-pointer" [hit]="hit"
                            [routerLink]="['/facilities' , hit.facility, 'locations', hit.location, 'items']"
                          attribute="locationName"></ais-highlight>
                        }
                        @if (!hit.location) {
                          <span>Jobsite</span>
                        }
                      </td>
                      <td class="mat-cell">
                        <ais-highlight class="cursor-pointer" [hit]="hit" attribute="uniqueItemId"
                          [routerLink]="['/item', hit.objectID]">
                        </ais-highlight>
                      </td>
                      <td class="mat-cell">{{hit.itemType}}</td>
                      <td class="mat-cell">
                        <ais-highlight class="cursor-pointer" [hit]="hit" attribute="eclipseId"
                          [routerLink]="['/item', hit.objectID]">
                        </ais-highlight>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </ng-template>
          </ais-hits>
          <ais-pagination></ais-pagination>
        </mat-card-content>
      </mat-card>
    </ais-instantsearch-->
  }
</div>
